/*
============================================================
ZB MODE — PRODUCT SIZE GATE
File: assets/zb-product-size-gate.js

- No default size
- Add to cart is truly disabled until size selection
- Clicking the locked area shows:
  PLEASE SELECT YOUR ZB SIZE FIRST.
============================================================
*/

(function () {

  function initializeSizeGate() {

    const forms = document.querySelectorAll(
      'body.template-product .product-single__form'
    );

    forms.forEach(function (form) {

      if (form.dataset.zbSizeGateInitialized === 'true') {
        return;
      }

      const formId = form.getAttribute('id');

      const sizeInputs = Array.from(
        document.querySelectorAll(
          'body.template-product input[name="Size"][data-variant-input]'
        )
      ).filter(function (input) {
        return input.getAttribute('form') === formId;
      });

      if (!sizeInputs.length) {
        return;
      }

      const addButton = form.querySelector(
        'button[name="add"], [data-add-to-cart]'
      );

      if (!addButton) {
        return;
      }

      form.dataset.zbSizeGateInitialized = 'true';


      /* ====================================================
         NO DEFAULT SIZE
         ==================================================== */

      sizeInputs.forEach(function (input) {
        input.checked = false;
      });


      /* ====================================================
         WRAP ADD TO CART BUTTON
         Allows us to catch clicks while the real button
         remains disabled.
         ==================================================== */

      const wrapper = document.createElement('div');

      wrapper.className = 'zb-size-gate-button-wrap';

      addButton.parentNode.insertBefore(
        wrapper,
        addButton
      );

      wrapper.appendChild(addButton);


      /* Invisible click catcher */
      const blocker = document.createElement('div');

      blocker.className = 'zb-size-gate-blocker';
      blocker.setAttribute('role', 'button');
      blocker.setAttribute('tabindex', '0');
      blocker.setAttribute(
        'aria-label',
        'Please select your ZB size first'
      );

      wrapper.appendChild(blocker);


      /* ====================================================
         MESSAGE
         ==================================================== */

      const message = document.createElement('div');

      message.className = 'zb-size-required-message';
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');

      message.textContent =
        'PLEASE SELECT YOUR ZB SIZE FIRST.';

      wrapper.insertAdjacentElement(
        'afterend',
        message
      );


      function hasSelectedSize() {
        return sizeInputs.some(function (input) {
          return input.checked;
        });
      }


      function showMessage() {
        message.classList.add('is-visible');
      }


      function hideMessage() {
        message.classList.remove('is-visible');
      }


      /* ====================================================
         LOCK
         ==================================================== */

      function lockButton() {

        addButton.disabled = true;

        addButton.setAttribute(
          'aria-disabled',
          'true'
        );

        addButton.classList.add(
          'zb-size-required'
        );

        wrapper.classList.add(
          'is-zb-size-locked'
        );
      }


      /* ====================================================
         UNLOCK
         ==================================================== */

      function unlockButton() {

        addButton.disabled = false;

        addButton.removeAttribute(
          'aria-disabled'
        );

        addButton.classList.remove(
          'zb-size-required'
        );

        wrapper.classList.remove(
          'is-zb-size-locked'
        );

        hideMessage();
      }


      /* Initial state */
      lockButton();


      /* ====================================================
         SIZE SELECTION
         ==================================================== */

      sizeInputs.forEach(function (input) {

        input.addEventListener(
          'change',
          function () {

            if (hasSelectedSize()) {
              unlockButton();
            } else {
              lockButton();
            }

          }
        );

      });


      /* ====================================================
         CLICK ON LOCKED BUTTON AREA
         ==================================================== */

      blocker.addEventListener(
        'click',
        function () {

          if (!hasSelectedSize()) {
            showMessage();
          }

        }
      );


      blocker.addEventListener(
        'keydown',
        function (event) {

          if (
            event.key === 'Enter' ||
            event.key === ' '
          ) {
            event.preventDefault();

            if (!hasSelectedSize()) {
              showMessage();
            }
          }

        }
      );


      /* ====================================================
         EXTRA SUBMIT PROTECTION
         ==================================================== */

      form.addEventListener(
        'submit',
        function (event) {

          if (!hasSelectedSize()) {

            event.preventDefault();
            event.stopImmediatePropagation();

            showMessage();
          }

        },
        true
      );

    });

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initializeSizeGate
    );

  } else {

    initializeSizeGate();

  }


  document.addEventListener(
    'shopify:section:load',
    initializeSizeGate
  );

})();